module.exports = __webpack_public_path__ + "static/ClickedOutPatientMedicalYellow-dc95559cfab8095d3962dc4a6a51c303.png";